import type { IconSvgObject } from './types';

const SearchCircleIcon: IconSvgObject = [
  ["path", { d: "M22 12.0001C22 6.4772 17.5228 2.00005 12 2.00005C6.47715 2.00005 2 6.4772 2 12.0001C2 17.5229 6.47715 22.0001 12 22.0001C17.5228 22.0001 22 17.5229 22 12.0001Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M14.8284 14.8285L17 17.0001M16 12.0001C16 9.79091 14.2091 8.00005 12 8.00005C9.79086 8.00005 8 9.79091 8 12.0001C8 14.2092 9.79086 16.0001 12 16.0001C14.2091 16.0001 16 14.2092 16 12.0001Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default SearchCircleIcon;
